import { memo } from 'react';
import { IImages } from '../../../mechanics/characters/Character';
import { uiSlice } from '../../../store/reducers/uiReducer';
import { useAppDispatch } from '../../../store/store';
import ImgWithFallback from '../../ui/ImgWithFallback';

interface ICharacterRaceProps {
    characterSkill: IImages
    toolTip: string
    setIsToolTipView: React.Dispatch<React.SetStateAction<boolean>>
}

const CreateCharacterSkill = ({ characterSkill, toolTip, setIsToolTipView }: ICharacterRaceProps) => {
    const dispatch = useAppDispatch()
    const { setToolTipContent } = uiSlice.actions

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    return (
        <li className={`skills__elem`} onMouseEnter={() => callToolTip(toolTip)} onMouseLeave={() => setIsToolTipView(false)}>
            <ImgWithFallback src={characterSkill.webp} fallbackSrc={characterSkill.img} />
        </li>
    );
};

export default memo(CreateCharacterSkill);